import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, Inject, OnInit, signal, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { HttpStatusCode } from 'axios';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { InceptedApeByAdvisors } from '../../dashboard-interfaces/incepted-ape-by-advisors.interface';
import { DashboardGetAdvisorsDataByBranchService } from '../../dashboard-services/dashboard-get-advisors-data-by-branch/dashboard-get-advisors-data-by-branch.service';
import { MatDividerModule } from '@angular/material/divider';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-incepted-ape-branch-advisors',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    ReactiveFormsModule,
    MatDividerModule
  ],
  templateUrl: './view-incepted-ape-branch-advisors.dialog.html',
  styleUrl: './view-incepted-ape-branch-advisors.dialog.scss'
})
export class ViewInceptedApeBranchAdvisorsDialog implements OnInit, AfterViewInit {

  private router = inject(Router);
  private snackBarService = inject(SnackbarService);
  private dashboardGetAdvisorsDataByBranchService = inject(DashboardGetAdvisorsDataByBranchService);

  private inceptedApeByAdvisorData: InceptedApeByAdvisors[] = [];
  protected inceptedApeByAdvisorTableDisplayDataRow: string[] = ["repCode", "personName", "monthSinglife", "monthSinglifeCase", "monthNonsinglife", "monthNonsinglifeCase", "yearSinglife", "yearSinglifeCase", "yearNonsinglife", "yearNonsinglifeCase", "yearTotal"];
  protected inceptedApeByAdvisorTableDisplayFirstColumn: string[] = ['repCode', 'personName', 'header-row2-month-singlife-group', 'header-row2-month-nonsinglife-group', 'header-row2-year-singlife-group', 'header-row2-year-nonsinglife-group', 'yearTotal'];
  protected inceptedApeByAdvisorTableDisplaySecondColumn: string[] = ['monthSinglife', 'monthSinglifeCase', 'monthNonsinglife', 'monthNonsinglifeCase', 'yearSinglife', 'yearSinglifeCase', 'yearNonsinglife', 'yearNonsinglifeCase'];
  protected inceptedApeByAdvisorTableDataSource = new MatTableDataSource<InceptedApeByAdvisors>();

  inceptedApeBranchAdvisorTableFilterFc = new FormControl("");

  @ViewChild('inceptedApeByAdvisorTablePaginator')
  inceptedApeByAdvisorTablePaginator!: MatPaginator;
  @ViewChild('inceptedApeByAdvisorTableSort')
  inceptedApeByAdvisorTableSort = new MatSort();

  protected branchName: string = "";

  protected setSprinner = signal(false);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public matData: any
  ) { }

  async ngOnInit(): Promise<void> {
    this.branchName = this.matData.branchName;
    await this.getDashboardDataByBranchAdvisors(this.branchName);

    this.inceptedApeByAdvisorTableDataSource.data = this.inceptedApeByAdvisorData;
  }

  ngAfterViewInit(): void {
    this.inceptedApeByAdvisorTableDataSource.paginator = this.inceptedApeByAdvisorTablePaginator;
    this.inceptedApeByAdvisorTableDataSource.sort = this.inceptedApeByAdvisorTableSort;
  }

  private async getDashboardDataByBranchAdvisors(branchName: string) {
    this.setSprinner.set(true);

    const responseData = await this.dashboardGetAdvisorsDataByBranchService
      .getDashboardBranchwiseAdvisors(branchName)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      const advisorData: any[] = responseData.data.responsedata;
      advisorData.forEach((advisorItem) => {
        this.inceptedApeByAdvisorData.push({
          repCode: advisorItem.piasRepCode.toString(),
          personName: advisorItem.agentRealName.toString() || advisorItem.agentPreferredName.toString(),
          branch: advisorItem.branch.toString(),
          monthSinglife: Number.parseInt(advisorItem.mtdSinglife.toString()),
          monthSinglifeCase: Number.parseInt(advisorItem.mtdSinglifeCase.toString()),
          monthNonsinglife: Number.parseInt(advisorItem.mtdNonSinglife.toString()),
          monthNonsinglifeCase: Number.parseInt(advisorItem.mtdNonSinglifeCase.toString()),
          yearSinglife: Number.parseInt(advisorItem.ytdSinglife.toString()),
          yearSinglifeCase: Number.parseInt(advisorItem.ytdSinglifeCase.toString()),
          yearNonsinglife: Number.parseInt(advisorItem.ytdNonSinglife.toString()),
          yearNonsinglifeCase: Number.parseInt(advisorItem.ytdNonSinglifeCase.toString()),
          yearTarget: 0,
          yearTotal: (Number.parseInt(advisorItem.ytdSinglife.toString()) + Number.parseInt(advisorItem.ytdNonSinglife.toString())),
          userGroup: advisorItem.userGroup.toString()
        });
      });

      // this.inceptedApeByAdvisorData = this.inceptedApeByAdvisorData.filter(item => item.userGroup !== 'Affinity');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  protected clearSearchField() {
    this.inceptedApeBranchAdvisorTableFilterFc.setValue('');
    this.__applyInceptedApeBranchAdvisorsDataFilter();
  }

  protected __applyInceptedApeBranchAdvisorsDataFilter() {
    let filterValue: string = this.inceptedApeBranchAdvisorTableFilterFc.value?.toString() || '';

    let tempInceptedApeByAdvisorTableData: InceptedApeByAdvisors[] = [];

    if (filterValue) {
      tempInceptedApeByAdvisorTableData = this.inceptedApeByAdvisorData.filter(apeData =>
        apeData.repCode.toString().includes(filterValue)
        || apeData.personName.toLowerCase().includes(filterValue.toLowerCase()
        ));
    } else {
      tempInceptedApeByAdvisorTableData = this.inceptedApeByAdvisorData;
    }

    this.inceptedApeByAdvisorTableDataSource.data = tempInceptedApeByAdvisorTableData;
  }
}
